<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <!-- Basic Alerts start -->
    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <!-- <div class="card-header mb-75">
              <h4 class="card-title">تصفية</h4>
            </div> -->
            <div class="card-body pb-1">
                <div class="card-datatable text-nowrap">
                    <form [formGroup]="searchForm" class="row mb-2">
                        <div class="col-md-4" *ngIf="organizers">
                            <div class="mb-1">
                                <label class="form-label" for="dateFrom">المشرف <span class="text-danger">*</span></label>
                                <ng-select 
                                    [items]="organizers"
                                    bindLabel="organizer"
                                    bindValue="id"
                                    formControlName="OrganizerId"
                                    (change)="search()"
                                    placeholder="اختر المشرف">
                                </ng-select>
                                <div *ngIf="searchForm.get('OrganizerId')?.errors?.required && searchForm.get('OrganizerId')?.touched" class="text-danger small">
                                    <div *ngIf="searchForm.get('OrganizerId')?.hasError('required')">برجاء اختيار المشرف</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-1">
                                  <label class="form-label" for="dateFrom">التاريخ من <span class="text-danger">*</span></label>
                                  <input type="date" id="dateFrom" class="form-control" name="DateFrom" formControlName="DateFrom" (change)="search()">
                                  <div *ngIf="searchForm.get('DateFrom')?.errors?.required && searchForm.get('DateFrom')?.touched" class="text-danger small">
                                    <div *ngIf="searchForm.get('DateFrom')?.hasError('required')">برجاء اختيار التاريخ من</div>
                                  </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-1">
                                <label class="form-label" for="dateTo">التاريخ الي <span class="text-danger">*</span></label>
                                <input type="date" id="dateTo" class="form-control" name="DateTo" formControlName="DateTo" (change)="search()">
                                <div *ngIf="searchForm.get('DateTo')?.errors?.required && searchForm.get('DateTo')?.touched" class="text-danger small">
                                    <div *ngIf="searchForm.get('DateTo')?.hasError('required')">برجاء اختيار التاريخ الي</div>
                                </div>
                                <!-- Add this new error message -->
                                <div *ngIf="searchForm.errors?.dateRangeInvalid && searchForm.get('DateTo')?.touched" class="text-danger small">
                                    التاريخ الي يجب أن يكون بعد التاريخ من
                                </div>
                            </div>
                        </div>
                        <div class="col-12" style="text-align: end;margin-top: 10px;">
                            <button class="btn btn-outline-primary waves-effect" (click)="search()">
                                <span>بحث</span>
                            </button>
                        </div>
                    </form>
                    <!-- <hr> -->
                    <div class="d-flex mb-3" style="align-items: center;justify-content: space-between;">
                        <div class="d-flex">
                            <!-- <button class="btn btn-outline-primary waves-effect py-0 ml-2" type="button" (click)="modalOpenDefault(modalDefault)" rippleEffect>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.66602 11.9199V13.2533C2.66602 13.9896 3.26297 14.5866 3.99935 14.5866H11.9993C12.7357 14.5866 13.3327 13.9896 13.3327 13.2533V11.9199" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.66602 6.58675L7.99935 3.25342L11.3327 6.58675" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.99935 3.25342V11.2534" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                                    
                                <span class="pl-1">استخراج</span>
                            </button> -->
                        </div>
                    </div>
                    
                    <!-- ngx-datatable-custom-checkbox -->
                     <div class="row" *ngIf="showTable">
                        <div class="col-12 text-left mb-2">
                            <button class="btn btn-outline-primary waves-effect ml-2" type="button" rippleEffect (click)="export()"> 
                                <span class="pr-1">Excel</span>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="17" height="17" class="main-grid-item-icon" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" x2="12" y1="15" y2="3" />
                                </svg>
                            </button>
                        </div>
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>المشرف</th>
                                            <th>البريد الالكتروني</th>
                                            <th>رقم الهاتف</th>
                                            <th>اسم المناسبة</th>
                                            <th>تاريخ البدء</th>
                                            <th>تاريخ الانتهاء</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let item of organizerReport">
                                        <td>{{item['#']}}</td>
                                        <td>{{item['organizer']}}</td>
                                        <td>{{item['email']}}</td>
                                        <td>{{item['phoneNumber']}}</td>
                                        <td>{{item['event']}}</td>
                                        <td>{{item['startDate'] | date: 'yyyy-MM-dd'}}</td>
                                        <td>{{item['endDate'] | date: 'yyyy-MM-dd'}}</td>
                                      </tr>
                                      <tr *ngIf="organizerReportLength === 0">
                                        <td class="text-center" colspan="7">لا توجد بيانات متاحة</td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                     </div>
                    

                    <div class="modal-size-default d-inline-block">
                      <ng-template #modalDelete let-modal>
                        <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel160"></h5>
                          <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close" title="إغلاق">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center" tabindex="0" ngbAutofocus>
                          <h4>تأكيد حذف المستخدم</h4>
                          <p class="pt-1">سيتم حذف المستخدم وجميع بياناته . هل مازلت تريد المتابعة ؟</p>
                          <div class="demo-spacing-0">
                            <div class="alert alert-danger p-75" role="alert" dir="rtl">
                              <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                              <span>سيتم حذف جميع البيانات ولن يكون بالإمكان استعادتها لاحقًا.</span>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer m-auto">
                          <button type="button" class="btn btn-danger" (click)="modal.close('Accept click');confirmDelete()" rippleEffect>
                            حذف
                          </button>
                          <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" rippleEffect>
                            تراجع
                          </button>
                        </div>
                      </ng-template>
                    </div>

                  </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Basic Alerts end -->
  </div>
</div>

<!-- <ngb-toast 
  *ngIf="toastService.message" 
  [autohide]="true" 
  (hidden)="toastService.clear()"
  style="position: fixed;left: 30px;top: 95px;"
  delay="5000"
  >
  <span style="color: #3F8260;">{{ toastService.message }} </span>
</ngb-toast> -->